import { render, staticRenderFns } from "./welcome-admin-tcr-campaign-registration.vue?vue&type=template&id=0488e248&scoped=true&"
import script from "./welcome-admin-tcr-campaign-registration.vue?vue&type=script&lang=js&"
export * from "./welcome-admin-tcr-campaign-registration.vue?vue&type=script&lang=js&"
import style0 from "./welcome-admin-tcr-campaign-registration.vue?vue&type=style&index=0&id=0488e248&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0488e248",
  null
  
)

export default component.exports